var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"generate-doc"},[(!_vm.finalPdf)?_c('div',[_c('p',{staticStyle:{"margin-top":"20px"}},[_vm._v(" Click Generate button to download final PDF document ")])]):_c('iframe',{attrs:{"src":_vm.finalPdf,"width":"100%","height":"650"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }